import { COLLECT_COUPON, DISPLAY_COUPON_POPUP, GET_COUPONS, STORE_COUPON, GET_COUPON_URL, GET_COUPON_USAGE, DISPLAY_COUPON_LIST_POPUP, GET_USER_COUPONS, GET_USABLE_COUPONS } from "../actions/coupon/type";
// import _ from 'lodash';

const initState = {collect_coupon_popup: false, coupon_detail: null, collect_coupon: false, store_coupon: null, couponUrl: null, couponsUsage: null, coupons: {data: [], count: 0}, user_coupons : null, usable_coupons : null}
export default function(state = initState, action) {
    switch (action.type) {
    case COLLECT_COUPON:
        return {...state, collect_coupon : action.payload}
    case DISPLAY_COUPON_POPUP:
        return {...state, collect_coupon_popup : action.payload.visible, coupon : action.payload.coupon}
    case GET_COUPONS : 
        const {data} = action.payload
        const incomingData = data? JSON.parse(JSON.stringify(data)): []
        const oldData = JSON.parse(JSON.stringify(state.coupons.data));
        const totalData = Object.assign(oldData, incomingData)
        return {...state, coupons : {data: totalData, count: totalData.length}}
    case STORE_COUPON :
        return {...state, store_coupon: action.payload}
    case GET_COUPON_URL:
        return {...state, couponUrl: action.payload}
    case GET_COUPON_USAGE:
        return {...state, couponsUsage: action.payload}
    case DISPLAY_COUPON_LIST_POPUP:
        return {...state, coupon_list_popup: action.payload}
    case GET_USER_COUPONS:
        return {...state, user_coupons : action.payload}
    case GET_USABLE_COUPONS: 
        return {...state, usable_coupons : action.payload}
    default: 
        return state;
    }
}